
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Logout extends Vue {
  @Prop({ default: 0 }) public textId;
  @Prop({ default: {} }) public modalRow;
  public list = [
    {
      title: "提现次数超过限制",
      content: "",
    },
  ];

  public mounted() {
    if (this.modalRow.content) {
      this.list[this.textId].content = this.modalRow.content;
    }
  }

  public onCancel() {
    this.$emit("closeModal");
  }
}
